import { render } from 'solid-js/web';
import { configureApi } from '~shared/lib/api';
import { App } from './App';
import './styles.css';

configureApi({ storageKey: 'member-verify:admin-password' });

const root = document.getElementById('root');
if (!root) throw new Error('#root missing');
render(() => <App />, root);
